"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_INTERACTION_TIMEOUT_REQUEST = exports.DEFAULT_TIMEOUT_REQUEST = exports.MILISECONDS_IN_A_SECOND = exports.USER_INTERACTION_TIMEOUT_SECONDS = exports.TIMEOUT_SECONDS = void 0;
exports.TIMEOUT_SECONDS = 2;
exports.USER_INTERACTION_TIMEOUT_SECONDS = 60;
exports.MILISECONDS_IN_A_SECOND = 1000;
exports.DEFAULT_TIMEOUT_REQUEST = exports.TIMEOUT_SECONDS * exports.MILISECONDS_IN_A_SECOND;
exports.USER_INTERACTION_TIMEOUT_REQUEST = exports.USER_INTERACTION_TIMEOUT_SECONDS * exports.MILISECONDS_IN_A_SECOND;
//# sourceMappingURL=messages.constants.js.map